export default __webpack_public_path__ + "static/media/password-generator.3fe47e75.gif";